// extracted by mini-css-extract-plugin
module.exports = {"icon":"InfoSection_icon__22G_y","open":"InfoSection_open__3QK7K","content":"InfoSection_content__2sO17"};